import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import {YoungEditInformationDto} from '../../model/dto/young-edit-information.dto';
import {Season} from '../../utils/helper/season.model';
import {Webservice} from './webservice';
import {Observable} from 'rxjs';
import {SimpleYoungDto} from '../../model/dto/simple-young.dto';
import {YoungAdditionnalInfoDto} from '../../model/dto/young-additionnal-info.dto';

@Injectable({
    providedIn: 'root'
})
export class YoungWebservice extends Webservice {

    constructor() {
        super();
        this.entity = 'youngs';
    }

    getYoung(youngId: number): Observable<SimpleYoungDto> {
        return this.http.get<SimpleYoungDto>(`${this.root}/public/${youngId}`);
    }

    getEventsFromYoung(youngId: number) {
        let params = new HttpParams();
        params = params.set('year', new Season().dateStart.getFullYear());
        return this.http.get(`${this.root}/${youngId}/events`, {params});
    }

    getInfosFromYoung(id: number): Observable<YoungAdditionnalInfoDto> {
        return this.http.get<YoungAdditionnalInfoDto>(`${this.root}/${id}/infos/`);
    }

    updateYoung(young: YoungEditInformationDto) {
        return this.http.post(`${this.root}/update`, young);
    }

    changeImgRight(idYoung: number) {
        return this.http.post(`${this.root}/change-image-right`, idYoung);
    }
}



